// import { httpsCallable, getFunctions } from 'firebase/functions';
// const functions = getFunctions();
import { FUNCTIONS_BASE_URL } from '../../shared/config/environment';

interface CreatePaymentIntentRequest {
  organizationId: string;
  amount: number; // Montant total (produits + livraison) en centimes
  currency: string;
  customerEmail: string;
  customerName: string;
  description: string;
  commission?: {
    grossAmount: number;
    commissionRate: number;
    fixedCommission: number;
    totalCommission: number;
    netAmount: number;
    applicationFeeAmount?: number;
  };
  organizationConfig?: any;
  metadata?: Record<string, string>;
}

interface CreatePaymentIntentResponse {
  paymentIntentId: string;
  clientSecret: string;
  amount: number;
  currency?: string;
  paymentMode?: 'stripe_connect' | 'stripe_api_key';
  stripePublishableKey?: string; // Clé publique Stripe à utiliser pour confirmer le paiement
  commissionAmount: number;
  netAmount: number;
  organizationId: string;
}

/**
 * Pure Stripe payment service for handling payment intents
 */
export class StripeService {
  /**
   * Create a payment intent for the given order
   */
  static async createPaymentIntent(
    data: CreatePaymentIntentRequest,
  ): Promise<CreatePaymentIntentResponse> {
    try {
      // Call the Firebase Cloud Function
      const response = await fetch("/api/createPaymentIntent", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error("Failed to create payment intent");
      }

      const result = await response.json();
      return result;
    } catch (_error) {
      console.error("Error creating payment intent:", _error);
      throw _error;
    }
  }

  /**
   * Alternative method using direct HTTP call to Firebase Cloud Functions
   * Use this if you want to call the function directly instead of through your backend
   */
  static async createPaymentIntentDirect(
    data: CreatePaymentIntentRequest,
  ): Promise<CreatePaymentIntentResponse> {
    try {
      // Replace YOUR_REGION and YOUR_PROJECT_ID with your actual values
      const functionUrl = `${FUNCTIONS_BASE_URL}/createMultiOrgPaymentIntent`;

      const response = await fetch(functionUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error("Failed to create payment intent");
      }

      const result = await response.json();
      return result;
    } catch (_error) {
      console.error("Error creating payment intent:", _error);
      throw _error;
    }
  }
}

// Legacy exports for backward compatibility
export const createPaymentIntent = StripeService.createPaymentIntent;
export const createPaymentIntentDirect =
  StripeService.createPaymentIntentDirect;
